/**
 * Maps author names to local author image files in /public/blog/authorImages/
 * Returns the path to the author image or null if not found
 */
export function getAuthorImagePath(authorName: string | undefined | null): string | null {
  if (!authorName || typeof authorName !== "string") {
    return null;
  }

  // Available author images
  const authorImages: Record<string, string> = {
    "Burkhard Berger": "/blog/authorImages/Burkhard Berger.jpg",
    "David Max": "/blog/authorImages/David Max.jpg",
    "David Stellini": "/blog/authorImages/David Stellini.jpg",
    "Emma Zoe": "/blog/authorImages/Emma Zoe.jpg",
    "Hanna F.": "/blog/authorImages/Hanna F..jpg",
    "James William": "/blog/authorImages/James William.jpg",
    "Laura Jasper": "/blog/authorImages/Laura Jasper.jpg",
    "Oleg Calugher": "/blog/authorImages/Oleg Calugher.jpg",
    "Stuart Diver": "/blog/authorImages/Stuart Diver.jpg",
  };

  // Direct match
  if (authorImages[authorName]) {
    return authorImages[authorName];
  }

  // Try case-insensitive match
  const normalizedName = authorName.trim();
  const matchedKey = Object.keys(authorImages).find(
    (key) => key.toLowerCase() === normalizedName.toLowerCase()
  );

  if (matchedKey) {
    return authorImages[matchedKey];
  }

  // No match found
  return null;
}

/**
 * Gets the author avatar URL, falling back to a default if local image not found
 */
export function getAuthorAvatar(
  authorName: string | undefined | null,
  fallbackAvatar?: string
): string {
  const localImage = getAuthorImagePath(authorName);
  
  if (localImage) {
    return localImage;
  }

  // Fallback to provided avatar or default
  if (fallbackAvatar) {
    return fallbackAvatar;
  }

  // Default fallback
  return `https://i.pravatar.cc/150?u=${encodeURIComponent(authorName || "unknown")}`;
}

